import ErrorScreen from 'app/src/errors/ErrorScreen'

const Unmatched = () => {
  return <ErrorScreen status={404} />
}

export const Component = Unmatched
export default Unmatched
